<template>
  <v-dialog
      :value="visiblePopup"
      :max-width="1600"
      @keydown.esc='onCloseClickButton'
      @click:outside="onCloseClickButton"
      content-class='screenshots-dialog'
      @keydown.left="prevCarouselItem"
      @keydown.right="nextCarouselItem"
    >
      <v-card class="screenshot-popup popup-wrapper">
        <div class='close-button-section'>
          <span class='close_btn' @click='onCloseClickButton'>
            <span class="material-icons-outlined">
              close
            </span>
          </span>
        </div>
        <div class='screenshots'>
          <v-carousel
            v-model="currentScreenshot"
          >
            <v-carousel-item
              v-for="(screenshot, i) in screenshotsUrls"
              :key="i"
            >
              <div class='port'>
                {{ getPortText(getAssetName(i), screenshot.port) }}
              </div>
              <img :src="screenshot.url" />
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-card>
</v-dialog>
</template>

<script>
import { getFileUrl } from '@/amplify/auth';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'ScreenshotPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    visiblePopup: {
      type: Boolean,
      required: true,
    },
    screenshotFocusedIndex: {
      type: Number,
      required: true,
    },
    screenshots: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      currentScreenshot: 0,
      screenshotsUrls: [],
      currentScreenshotObject: {},
    };
  },
  watch: {
    visiblePopup() {
      this.init();
    },
    screenshots: {
      async handler() {
        this.screenshotsUrls = [];
        if (this.visiblePopup) {
          if (this.screenshots.length > this.screenshotFocusedIndex) {
            this.screenshotsUrls.push({ url: await getFileUrl(this.screenshots[this.screenshotFocusedIndex].screenshot), port: this.screenshots[this.screenshotFocusedIndex].port });
          }
          for (let i = 0; i < this.screenshots.length; i += 1) {
            if (i !== this.screenshotFocusedIndex) {
              // eslint-disable-next-line no-await-in-loop
              const url = await getFileUrl(this.screenshots[i].screenshot);
              this.screenshotsUrls.push({ url, port: this.screenshots[i].port });
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    getAssetName(index) {
      return this.screenshots?.[index]?.asset || '';
    },
    getPortText(asset, port) {
      return asset ? `${asset}:${port}` : `${port}`;
    },
    init() {
      this.screenshotsUrls = [];
      this.currentScreenshot = 0;
    },
    onCloseClickButton() {
      this.$emit('close');
    },
    prevCarouselItem() {
      this.currentScreenshot = (this.currentScreenshot - 1 + this.screenshotsUrls.length) % this.screenshotsUrls.length;
    },
    nextCarouselItem() {
      this.currentScreenshot = (this.currentScreenshot + 1) % this.screenshotsUrls.length;
    },
  },
};
</script>

<style lang='scss'>
.v-dialog {
  &.screenshots-dialog {
    height: 100% !important;
  }
}
.screenshot-popup {
  .v-carousel {
    height: 100% !important;
  }
  .v-carousel__controls {
    background: var(--bg-tertiary);
    .v-btn {
      color: var(--text-secondary) !important;
    }
    .v-btn--active .v-icon {
      opacity: 1;
      color: var(--brand-primary) !important;
    }
    .v-icon {
      opacity: 0.5;
    }
  }
  .v-carousel__item {
    height: 100% !important;
    overflow-y: auto;
    justify-content: center;
    .v-responsive__content {
      height: max-content;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    img {
      height: fit-content;
      width: 100%;
    }
  }
  .v-btn {
    height: 36px !important;
  }
}
</style>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.screenshot-popup {
  &.popup-wrapper {
    height: 100% !important;
    max-width: rem(1600);
    padding: $space-6 0;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    .screenshots {
      height: 100% !important;
      position: relative;
      .port {
        position: sticky;
        top: $space-5;
        padding: $space-2;
        min-width: rem(50);
        text-align: center;
        max-width: fit-content;
        margin-bottom: $space-5;
        justify-content: center;
        box-sizing: border-box;
        color: var(--text-inverse);
        border: $border-width-thin solid var(--bg-secondary);
        background-color: var(--brand-primary);
        border-radius: $radius-md;
      }
    }
    .close-button-section {
      margin-right: rem(15);
      z-index: 2;
      .close_btn {
        float: right;
        &:hover {
          cursor: pointer;
          color: var(--brand-primary);
        }
      }
    }
  }
}
</style>
